.auth-screen {
  align-items: center;
  display: grid;
  min-height: var(--xiaocai-app-viewport-height);
  padding: calc(var(--xiaocai-safe-top) + 24px) calc(var(--xiaocai-safe-right) + 24px)
    calc(var(--xiaocai-safe-bottom) + 24px) calc(var(--xiaocai-safe-left) + 24px);
}

.auth-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.08);
  margin: 0 auto;
  max-width: 520px;
  padding: 24px;
  width: 100%;
}

.auth-card__eyebrow {
  color: var(--xiaocai-primary);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.auth-card h1 {
  color: #0f172a;
  font-size: 32px;
  margin: 8px 0 0;
}

.auth-card p {
  color: #475569;
  margin: 12px 0 0;
}

.auth-form {
  display: grid;
  gap: 12px;
  margin-top: 20px;
}

.auth-form__label {
  color: #334155;
  font-size: 14px;
  font-weight: 600;
}

.auth-form__input {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  color: #0f172a;
  outline: none;
  padding: 10px 12px;
  width: 100%;
}

.auth-form__input:focus {
  border-color: var(--xiaocai-primary);
  box-shadow: 0 0 0 3px rgba(var(--xiaocai-primary-rgb), 0.18);
}

.auth-form__button {
  background: var(--xiaocai-primary);
  border: 0;
  border-radius: 10px;
  color: #ffffff;
  cursor: pointer;
  font-weight: 600;
  padding: 10px 14px;
}

.auth-form__button:hover {
  background: var(--xiaocai-primary-hover);
}

.auth-form__button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
